import angular from 'angular';

export default function selectedRow(Utils) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      row: '=selectedRow',
    },
    require: '^ngModel',
    link($scope, $element, $attrs, $ctrl) {
      const { datepickerMode } = $scope.$parent.$parent;
      const firstRowDate = $scope.row[0].date;
      const currentDate = $ctrl.$viewValue;

      if (!angular.isDate(currentDate)) {
        return;
      }

      if (datepickerMode === 'day') {
        const weeksDiff = Math.floor((currentDate - firstRowDate) / 1000 / 3600 / 24 / 7);
        $element.addClass(`contains-selected-${weeksDiff}`);
      } else if (datepickerMode === 'month') {
        const lastDayInRange = Utils.addDays(Utils.addMonths(firstRowDate, 3), -1);
        const currentTimestamp = currentDate.getTime();
        if (
          firstRowDate.getTime() < currentTimestamp &&
          currentTimestamp <= lastDayInRange.getTime()
        ) {
          $element.addClass('contains-selected-0');
        }
      }
    },
  };
}
